import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-filters-dropdown',
    templateUrl: './filters-dropdown.component.html',
    styleUrls: ['./filters-dropdown.component.scss'],
    imports: [BsDropdownModule, TranslateModule, NgClass],
})
export class FiltersDropdownComponent {
    @Input() addedFilters = {
        attachments: false,
        fields: false,
    };

    @Output() addFilter = new EventEmitter();
}
